import {OrderWrappingMod, OrderWrappingType} from '~/types/types';
import {getOrderWrappingTypes, getWrappers as getWrappersApi } from '~/api/wrapping';
import { Wrapping } from '~~/types/api';

export type WrappingType = 'wrappingByCode' | 'wrappingToView'
export type WrappingCode = 'extraPackageVolume'|'extraBlackPackageVolume'|'bubbleFilmVolume'|'cardboardVolume'|'box1'|'box2'
    |'box3'|'box4'|'bag1'|'bag2'|'safePackage'|'hardPackageVolume'|'palletCollar'|'palletising'|'removePackage' | string

export const useWrappingStore = defineStore('wrapping', () => {
  const orderWrappingTypes = ref([] as OrderWrappingType[])
  const wrappers = ref<Wrapping[]>([])
  const mainWrappers = {
    extraPackageVolume: 'Прозрачная плёнка',
    extraBlackPackageVolume: 'Чёрная плёнка',
    bubbleFilmVolume: 'Воздушно-пузырьковая плёнка',
    cardboardVolume: 'Упаковка в картон',
    box1: 'Коробка картонная',
    box2: 'Коробка картонная',
    box3: 'Коробка картонная',
    box4: 'Коробка картонная',
    bag1: 'Мешок полипропиленовый',
    // bag2: 'Мешок полипропиленовый',
    safePackage: 'Сейф-пакет',
    hardPackageVolume: 'Обрешётка (ЖУ)',
    palletCollar: 'Паллетный борт',
    palletising: 'Паллетирование',
    removePackage: 'Разбор упаковки на адресе получателя*'
  }

  const numericCodes = computed((): string[] => {
    const numericCodes: string[] = []
    orderWrappingTypes.value.forEach((item) => {
      if (item.id) {
        item.list.forEach((el) => {
          if (el.type === 'numeric') {
            numericCodes.push(el.code)
          }
        })
      } else if (item.list[0].type === 'numeric') {
        numericCodes.push(item.list[0].code)
      }
    })
    return numericCodes
  })

  const mods = computed((): { mod: OrderWrappingMod, key: string }[] => {
    return Object.keys(orderWrappingTypes.value).reduce((conditions: { mod: OrderWrappingMod, key: string }[], key) => {
      if (orderWrappingTypes.value[key]?.list?.[0]?.mod?.condition.cargo.dimension) {
        conditions.push({
          mod: orderWrappingTypes.value[key].list?.[0]?.mod,
          key: orderWrappingTypes.value[key].list?.[0]?.code
        })
      }
      return conditions
    }, [])
  })

  const getWrappingItems = [
    {title: 'Без упаковки', value: null},
    {title: 'Паллетный борт', value: 'palletCollar'},
    {title: 'с разбором', value: 'hardPackageVolumeUOD'},
    {title: 'без разбора', value: 'hardPackageVolume'},
    {title: 'Прозрачный стрейч', value: 'palletizingExtraPackageVolume'},
    {title: 'Чёрный стрейч', value: 'palletizingExtraBlackPackageVolume'},
    {title: 'Воздушно-пузырьковая плёнка', value: 'palletizingBubbleFilmVolume'},
    {title: 'без разбора', value: 'hardPackageVolume_WP'},
    {title: 'с разбором', value: 'hardPackageVolumeUOD_WP'},
    {title: 'Прозрачный стрейч', value: 'palletizingExtraPackageVolumeOD'},
    {title: 'Чёрный стрейч', value: 'palletizingExtraBlackPackageVolumeOD'},
    {title: 'Воздушно-пузырьковая плёнка', value: 'palletizingBubbleFilmVolumeOD'},
    {title: 'Прозрачная плёнка', value: 'extraPackageVolume'},
    {title: 'Чёрная плёнка', value: 'extraBlackPackageVolume'},
    {title: 'Воздушно-пузырьковая плёнка', value: 'bubbleFilmVolume'},
    {title: 'Упаковка в картон', value: 'cardboardVolume'}
  ]

  function getWrappingByCode(code: WrappingCode) {
    return wrappers.value.find(wrapping => wrapping.code === code)
  }

  function getWrappingToView(wrapperList?: Wrapping[]|undefined): Wrapping[] {
    if (!wrapperList) {
      wrapperList = wrappers.value
    }
    return wrapperList
      .filter(wrapping => mainWrappers[wrapping.code])
      .map(wrapping => ({
        ...wrapping,
        name: mainWrappers[wrapping.code]
      }))
  }

  async function getWrapping() {
    if ( wrappers.value.length ) {
      return wrappers
    }
    wrappers.value = await getWrappersApi({ price: true, hidden: true })
    return wrappers.value
  }

  // Инициализация
  getWrapping().then()
  getOrderWrappingTypes().then(types => orderWrappingTypes.value = types)

  return {
    orderWrappingTypes,
    numericCodes,
    mods,
    getWrappingItems,
    getWrapping,
    getWrappingByCode,
    getWrappingToView
  }
})
